import { render } from "./ImportPackages.vue?vue&type=template&id=235070af"
import script from "./ImportPackages.vue?vue&type=script&lang=js"
export * from "./ImportPackages.vue?vue&type=script&lang=js"

import "./ImportPackages.vue?vue&type=style&index=0&id=235070af&lang=css"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__